import authRules from '../authRules';

const submitApprovals = (user) => {
  const { approvalsSubmit } = user.securityLevels;
  if (approvalsSubmit >= authRules.submitApprovals.approvalsSubmit) {
      return true;
  } else {
      return false;
    }
  }

export default submitApprovals;


// WEBPACK FOOTER //
// ./src/AuthLogic/rules/submitApprovals.js